
import React from 'react';
import { Language } from '../types';
import { translations } from '../translations';

interface ImageUploaderProps {
  id: string;
  label: string;
  onUpload: (url: string) => void;
  currentImage: string | null;
  language: Language;
}

export const ImageUploader: React.FC<ImageUploaderProps> = ({ id, label, onUpload, currentImage, language }) => {
  const t = translations[language];

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        onUpload(event.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm font-medium text-slate-400">{label}</label>
      <div className="relative h-40 group cursor-pointer border-2 border-dashed border-slate-700 hover:border-indigo-500 transition-all rounded-xl bg-slate-800/50 flex items-center justify-center overflow-hidden">
        {currentImage ? (
          <img src={currentImage} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" alt="Preview" />
        ) : (
          <div className="flex flex-col items-center gap-2 text-slate-500">
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span className="text-xs text-center px-2">{t.click_to_upload}</span>
          </div>
        )}
        <input 
          type="file" 
          id={id}
          accept="image/*"
          className="absolute inset-0 opacity-0 cursor-pointer"
          onChange={handleFileChange}
        />
      </div>
    </div>
  );
};
